import {equals} from 'ramda';

import type {
  PricedItemBatchOperation,
  TrimFeatureAssignment,
  TrimFeatureAssignmentInput,
} from '@dms/api/new-vehicle';

import {PricedItemGroupEntryChanged} from '../types/PricedItemGroupEntryChanged';

/**
 * The `trimFeatureAssignment.replace` of a trim's equipment change, built when it is sent: with the
 * trim version read now, and only while the trim's assignments are still the ones `next` was made
 * from. A change of them meanwhile (another author, another tab) fails with
 * PricedItemGroupEntryChanged, so it is not overwritten.
 */
export const assignmentReplaceOperation = async (options: {
  trimId: string;
  /** The assignments `next` was made from. */
  base: TrimFeatureAssignment[];
  next: TrimFeatureAssignmentInput[];
  readTrimVersion: () => Promise<number>;
  readAssignments: () => Promise<TrimFeatureAssignment[]>;
}): Promise<PricedItemBatchOperation> => {
  const [version, current] = await Promise.all([
    options.readTrimVersion(),
    options.readAssignments(),
  ]);
  if (!equals(current, options.base)) {
    throw new PricedItemGroupEntryChanged();
  }
  return {
    type: 'trimFeatureAssignment.replace',
    targetId: options.trimId,
    body: {version, assignments: options.next},
  };
};
